import { Box, Card, CardContent, Typography } from "@mui/material";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";

const TopSummaryRow = ({
  totalUsers,
  subscriptionRate,
  subscribedUsers,
  profileCompletedRate,
  profileCompletedCount,
  deactivatedAccounts,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        mb: 1,
        display: "grid",
        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        gap: 1,
      }}
    >
      {/* Total Users */}
      <Card>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography className="dash-card-title" gutterBottom>
              Total Users
            </Typography>

            <Box
              component="img"
              src="/icons/users.svg"
              alt="users icon"
              sx={{ width: 22, height: 22, mb: 1 }}
            />
          </Box>
          <Typography
            variant="h2"
            sx={{
              textAlign: "center",
              mt: 4,
              fontWeight: 700,
              fontSize: "60px",
            }}
          >
            {totalUsers}
          </Typography>
        </CardContent>
      </Card>

      {/* Subscription Rate */}
      <Card>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography className="dash-card-title" gutterBottom>
              Subscription Rate
            </Typography>

            <Box
              component="img"
              src="/icons/reset.svg"
              alt="reset icon"
              sx={{ width: 22, height: 32, mb: 1 }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Gauge
              value={subscriptionRate}
              min={0}
              max={100}
              startAngle={-90}
              endAngle={90}
              innerRadius={70}
              width={220}
              height={120}
              text={({ value }) => `${Math.round(value)}%`}
              sx={{
                [`& .${gaugeClasses.valueText}`]: {
                  fontSize: 40,
                  fontWeight: 700,
                  fill: "#000",
                  transform: "translateY(-18px)",
                },
                [`& .${gaugeClasses.valueArc}`]: {
                  fill: "#003ABA",
                },
                [`& .${gaugeClasses.referenceArc}`]: {
                  fill: "#EFF3FE",
                },
              }}
            />
          </Box>

          <Typography
            variant="caption"
            sx={{
              textAlign: "center",
              fontSize: 16,
              display: "block",
              color: "#003ABA",
              mt: 1,
            }}
          >
            {subscribedUsers} of {totalUsers} subscribed
          </Typography>
        </CardContent>
      </Card>

      {/* Profile Completion Rate */}
      <Card>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography className="dash-card-title" gutterBottom>
              Profile Completion Rate
            </Typography>

            <Box
              component="img"
              src="/icons/check-mark.svg"
              alt="check mark icon"
              sx={{ width: 22, height: 22, mb: 1 }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Gauge
              value={profileCompletedRate}
              min={0}
              max={100}
              startAngle={-90}
              endAngle={90}
              innerRadius={70}
              width={220}
              height={120}
              text={({ value }) => `${Math.round(value)}%`}
              sx={{
                [`& .${gaugeClasses.valueText}`]: {
                  fontSize: 40,
                  fontWeight: 700,
                  fill: "#000",
                  transform: "translateY(-18px)",
                },
                [`& .${gaugeClasses.valueArc}`]: {
                  fill: "#003ABA",
                },
                [`& .${gaugeClasses.referenceArc}`]: {
                  fill: "#EFF3FE",
                },
              }}
            />
          </Box>

          <Typography
            variant="caption"
            sx={{
              textAlign: "center",
              fontSize: 16,
              display: "block",
              color: "#003ABA",
              mt: 1,
            }}
          >
            {profileCompletedCount} of {totalUsers} completed
          </Typography>
        </CardContent>
      </Card>

      {/* Deactivated Accounts */}
      <Card>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography className="dash-card-title" gutterBottom>
              Deactivated Accounts
            </Typography>

            <Box
              component="img"
              src="/icons/users.svg"
              alt="users icon"
              sx={{ width: 22, height: 22, mb: 1 }}
            />
          </Box>
          <Typography
            variant="h2"
            color="#BE0000"
            sx={{
              textAlign: "center",
              mt: 5,
              fontWeight: 700,
              fontSize: "60px",
            }}
          >
            {deactivatedAccounts}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TopSummaryRow;
